import React from "react";
import "./footer.css";

function Footer() {
    return (
        <div className="footer">
        <p></p>
      </div> 
    )
}
export default Footer